import React, { Component, PropTypes } from 'react';
import { SparkToggleSwitch } from '../ui/spark';

class ReactSparkCheckbox extends Component {
    componentDidMount() {
        this.checkBox = new SparkToggleSwitch(this.checkboxMount);
    }

    render() {
        let { status, isDefault, onChange, onClick, isDisabled } = this.props;
        return (
            <div>
                <label className="spark-toggle-switch" ref={node => (this.checkboxMount = node)}>
                    {/*<input className="spark-toggle__input" defaultChecked={status} type="checkbox" disabled={isDefault}
         onChange={onChange}/>*/}
                    <input
                        type="checkbox"
                        checked={status}
                        disabled={isDisabled}
                        onChange={onChange}
                        onClick={onClick}
                    />
                    {/* <span className="spark-toggle-switch__handle"/>
        <span className="spark-toggle-switch__track"/> */}
                    {status ? 'Active' : 'Inactive'}
                </label>
            </div>
        );
    }
}

ReactSparkCheckbox.propTypes = {
    status: PropTypes.bool,
    isDefault: PropTypes.bool,
    onChange: PropTypes.func
};

export default ReactSparkCheckbox;



// WEBPACK FOOTER //
// ./src/components/widgets/ReactSparkCheckbox.js